import { cn } from '@/lib/utils';

const Fraction = ({
  numerator,
  denominator,
  className,
}: {
  numerator: number;
  denominator: number;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'text-xs  text-gray-500 text-nowrap flex flex-row gap-0.5',
        className,
      )}
    >
      <span>{numerator}</span>
      <span>/</span>
      <span>{denominator}</span>
    </div>
  );
};

export default Fraction;
